export enum DecisionActionsEnum {
  DECISION_CATALOGS_INIT = 'DECISION_CATALOGS_INIT',
  DECISION_CREATE = 'DECISION_CREATE',
  DECISION_RESET = 'DECISION_RESET',
  DECISION_RELOAD = 'DECISION_RELOAD',
  DECISION_DELETE = 'DECISION_DELETE',
  DECISION_RESTORE = 'DECISION_RESTORE',
  DECISION_RESTORE_LATEST_SIGNED_VERSION = 'DECISION_RESTORE_LATEST_SIGNED_VERSION',
  DECISION_SET_ACTIONS_DROPDOWN_VISIBLE = 'DECISION_SET_ACTIONS_DROPDOWN_VISIBLE',
  DECISION_SET_URL_ID = 'DECISION_SET_URL_ID',
  DECISION_SET_RAW_DATA = 'DECISION_SET_RAW_DATA',
  DECISION_SEND_AGREEMENT = 'DECISION_SEND_AGREEMENT',

  DECISION_SET_ERROR_FIELDS = 'DECISION_SET_ERROR_FIELDS',
  DECISION_SIGN_SUBMIT_FAIL = 'DECISION_SIGN_SUBMIT_FAIL',

  DECISION_SET_ON_SAVE_BUTTON_CLICK = 'DECISION_SET_ON_SAVE_BUTTON_CLICK',

  DECISION_ADD_VISIBLE_MODALS = 'DECISION_ADD_VISIBLE_MODALS',
  DECISION_REMOVE_VISIBLE_MODALS = 'DECISION_REMOVE_VISIBLE_MODALS',

  DECISION_SET_INITIAL_FORM_VALUES = 'DECISION_SET_INITIAL_FORM_VALUES',
  DECISION_RESET_INITIAL_FORM_VALUES = 'DECISION_RESET_INITIAL_FORM_VALUES',

  DECISION_PATCH_RAW_DATA = 'DECISION_PATCH_RAW_DATA',
  DECISION_FILL_ORGANIZATIONS_AND_OBJECTS_BY_OTHER_PASSPORT = 'DECISION_FILL_ORGANIZATIONS_AND_OBJECTS_BY_OTHER_PASSPORT',

  DECISION_GET = 'DECISION_GET',
  DECISION_GET_REQUEST = 'DECISION_GET_REQUEST',
  DECISION_GET_SUCCESS = 'DECISION_GET_SUCCESS',
  DECISION_GET_FAILURE = 'DECISION_GET_FAILURE',

  DECISION_UPDATE = 'DECISION_UPDATE',
  DECISION_UPDATE_REQUEST = 'DECISION_UPDATE_REQUEST',
  DECISION_UPDATE_SUCCESS = 'DECISION_UPDATE_SUCCESS',
  DECISION_UPDATE_FAILURE = 'DECISION_UPDATE_FAILURE',

  DECISION_DRAFT_SAVE = 'DECISION_DRAFT_SAVE',
  DECISION_DRAFT_DELETE = 'DECISION_DRAFT_DELETE',

  DECISION_GET_HISTORY_CHANGES = 'DECISION_GET_HISTORY_CHANGES',
  DECISION_SET_HISTORY_CHANGES = 'DECISION_SET_HISTORY_CHANGES',
  DECISION_SET_HISTORY_CHANGES_IS_LOADING = 'DECISION_SET_HISTORY_CHANGES_IS_LOADING',
  DECISION_SET_HISTORY_CHANGES_IS_ON = 'DECISION_SET_HISTORY_CHANGES_IS_ON',

  DECISION_GET_SIGNED_HISTORY_CHANGES = 'DECISION_SIGNED_GET_HISTORY_CHANGES',
  DECISION_SET_SIGNED_HISTORY_CHANGES = 'DECISION_SET_SIGNED_HISTORY_CHANGES',

  DECISION_SET_FORM_REF = 'DECISION_SET_FORM_REF',

  DECISION_SIGN = 'DECISION_SIGN',
  DECISION_SIGN_UPLOAD_MODAL_APPLY = 'DECISION_SIGN_UPLOAD_MODAL_APPLY',
  DECISION_DELETE_SIGN = 'DECISION_DELETE_SIGN',
  DECISION_DOWNLOAD_XML = 'DECISION_DOWNLOAD_XML',
  DECISION_TRY_OPEN_SIGN_MODAL = 'DECISION_TRY_OPEN_SIGN_MODAL',
  DECISION_AGREEMENT_TEMPLATE_DOWNLOAD = 'DECISION_AGREEMENT_TEMPLATE_DOWNLOAD',

  DECISION_SET_KNO_ORGANIZATION_FORM_VALUE = 'DECISION_SET_KNO_ORGANIZATION_FORM_VALUE',
  DECISION_SET_SUPERVISION_TYPE_FORM_VALUE = 'DECISION_SET_SUPERVISION_TYPE_FORM_VALUE',
  DECISION_SET_KIND_VERSION_ID_FORM_VALUE = 'DECISION_SET_KIND_VERSION_ID_FORM_VALUE',
  DECISION_SET_STATUS = 'DECISION_SET_STATUS',

  DECISION_SET_IS_CAN_BE_SIGNED = 'DECISION_SET_IS_CAN_BE_SIGNED',
  DECISION_GET_ORDERS = 'DECISION_GET_ORDERS',
  DECISION_SET_ORDERS = 'DECISION_SET_ORDERS',

  DECISION_SET_REASONS_FORM_VALUE = 'DECISION_SET_REASONS_FORM_VALUE',

  DECISION_SAVE_BEFORE_SING_SUCCESS = 'DECISION_SAVE_BEFORE_SING_SUCCESS',

  DECISION_SET_LOADING = 'DECISION_SET_LOADING',
  DECISION_SET_WAS_FIRST_INIT = 'DECISION_SET_WAS_FIRST_INIT',

  DECISION_SET_STATUS_HINT_TEXT = 'DECISION_SET_STATUS_HINT_TEXT',
  DECISION_SET_STATUS_HINT_FIELDS = 'DECISION_SET_STATUS_HINT_FIELDS',
  DECISION_ERKNM_CANCEL_PRESCRIBE = 'DECISION_ERKNM_CANCEL_PRESCRIBE',
  DECISION_SET_PRESCRIBE_SIGNED = 'DECISION_SET_PRESCRIBE_SIGNED',

  DECISION_SET_EXTERNAL_PARAMS = 'DECISION_SET_EXTERNAL_PARAMS',

  DECISION_SET_PRESCRIPTION_OLD_RULES = 'DECISION_SET_PRESCRIPTION_OLD_RULES',
  DECISION_SET_PRESCRIPTION_FAILED = 'DECISION_SET_PRESCRIPTION_FAILED',

  DECISION_GET_CONTROL_OBJECTS_BY_NON_ERVK_ORGANIZATION = 'DECISION_GET_CONTROL_OBJECTS_BY_NON_ERVK_ORGANIZATION',
}
